import React, { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

interface PropTypes extends ComponentProps<"button"> {
  isLoading?: boolean;
  variant?: "solid" | "outline" | "ghost" | "destructive";
}

const Button = ({
  isLoading,
  disabled,
  children,
  className,
  variant = "solid",
  ...rest
}: PropTypes) => {
  return (
    <button
      {...rest}
      disabled={disabled || isLoading}
      className={twMerge(
        // base
        "flex items-center justify-center gap-1 rounded-lg border transition-colors",

        // disabled (highest priority)
        disabled &&
        "bg-gray-200 text-gray-400 border-gray-300 cursor-default",

        // loading (only when not disabled)
        !disabled &&
        isLoading &&
        "bg-transparent text-primary border-primary cursor-auto",

        // variants (only when not disabled & not loading)
        !disabled &&
        !isLoading &&
        variant === "solid" &&
        "bg-primary text-white border-primary md:hover:bg-transparent md:hover:text-primary ",

        !disabled &&
        !isLoading &&
        variant === "destructive" &&
        "bg-red-600 text-white border-red-600 hover:bg-red-600 hover:text-white",

        !disabled &&
        !isLoading &&
        variant === "outline" &&
        "bg-transparent text-primary border-primary",

        !disabled &&
        !isLoading &&
        variant === "ghost" &&
        "bg-transparent text-primary border-none",

        className
      )}

    >
      {isLoading && <span className="loading loading-spinner text-black" />}
      {children}
    </button>
  );
};

export default Button;
